import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixCloudResourceusageV1DataResourceUsageServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'editor._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/resource-usage',
        destPath: '/v1/resource-usage',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/resource-usage',
        destPath: '/v1/resource-usage',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/cloud-data/v1/resource-usage',
        destPath: '/v1/resource-usage',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/cloud-data/v1/resource-usage',
        destPath: '/v1/resource-usage',
      },
    ],
    _api_base_domain_: [
      {
        srcPath: '/_api/resourceusage.data-resource-usage',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/wix-data/v1/resource-usage',
        destPath: '/v1/resource-usage',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/wix-data/v1/resource-usage',
        destPath: '/v1/resource-usage',
      },
    ],
    _: [
      {
        srcPath: '/wix-data/v1/resource-usage',
        destPath: '/v1/resource-usage',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_data-resourceusage-service_data';

/** Get current Resource Usage */
export function getResourceUsage(payload: object): RequestOptionsFactory<any> {
  function __getResourceUsage({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.cloud.resourceusage.v1.resource_usage',
      method: 'GET' as any,
      methodFqn:
        'wix.cloud.resourceusage.v1.DataResourceUsageService.GetResourceUsage',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixCloudResourceusageV1DataResourceUsageServiceUrl({
        protoPath: '/v1/resource-usage',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getResourceUsage;
}
